console.log("related-products.js is loaded");

document.addEventListener("DOMContentLoaded", function() {
  var placeholder = Array.from(document.querySelectorAll("p")).find(p => p.textContent.trim() === "Related Products Placeholder");

  if (placeholder) {
    // Fetch related products using Shopify's recommendations API
    fetch(`/recommendations/products?product_id=${productId}&limit=4`)
      .then(response => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then(data => {
        if (!data || !data.products || data.products.length === 0) {
          placeholder.innerHTML = "<p>No related products found.</p>";
          return;
        }

        // Build HTML structure for related products
        let relatedHTML = '<h3>Related Products</h3><ul>';
        data.products.forEach(product => {
          relatedHTML += `
            <li>
              <a href="/products/${product.handle}">
                <img src="${product.featured_image}" alt="${product.title}">
                <p>${product.title}</p>
                <p>${Shopify.formatMoney(product.variants[0].price)}</p>
              </a>
            </li>
          `;
        });
        relatedHTML += '</ul>';
        
        // Replace placeholder content with related products
        placeholder.innerHTML = relatedHTML;
      })
      .catch(error => {
        console.error("Error fetching related products:", error);
        placeholder.innerHTML = "<p>Could not load related products.</p>";
      });
  }
});
